/**
 * Google Calendar color mappings.
 */

/**
 * Google Calendar colorId to hex color mapping.
 * These are the 11 standard colors available in Google Calendar.
 */
export const CALENDAR_COLORS: Record<string, string> = {
  '1': '#7986cb', // Lavender
  '2': '#33b679', // Sage
  '3': '#8e24aa', // Grape
  '4': '#e67c73', // Flamingo
  '5': '#f6bf26', // Banana
  '6': '#f4511e', // Tangerine
  '7': '#039be5', // Peacock
  '8': '#616161', // Graphite
  '9': '#3f51b5', // Blueberry
  '10': '#0b8043', // Basil
  '11': '#d50000', // Tomato
};

export const DEFAULT_CALENDAR_COLOR = '#039be5';

/** Schedule color type matching ScheduleEvent['color'] from day-schedule. */
export type ScheduleColor =
  | 'blue'
  | 'green'
  | 'purple'
  | 'orange'
  | 'gray'
  | 'yellow';

/**
 * Map Google Calendar colorId to schedule component color scheme.
 * Google Calendar uses color IDs "1" through "11".
 */
export function mapCalendarColorToScheduleColor(
  colorId?: string
): ScheduleColor {
  if (!colorId) {
    return 'gray';
  }

  switch (colorId) {
    case '1': // Lavender
      return 'purple';
    case '2': // Sage
      return 'green';
    case '3': // Grape
      return 'purple';
    case '4': // Flamingo
      return 'orange';
    case '5': // Banana
      return 'yellow';
    case '6': // Tangerine
      return 'orange';
    case '7': // Peacock
      return 'blue';
    case '8': // Graphite
      return 'gray';
    case '9': // Blueberry
      return 'blue';
    case '10': // Basil
      return 'green';
    case '11': // Tomato
      return 'orange';
    default:
      return 'gray';
  }
}

/**
 * Get the hex color for an event based on its Google Calendar colorId.
 */
export function getEventColor(colorId?: string): string {
  if (!colorId) {
    return DEFAULT_CALENDAR_COLOR;
  }
  return CALENDAR_COLORS[colorId] || DEFAULT_CALENDAR_COLOR;
}
